import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import helpersNumber from "../../../helpers/numbers";
import StatusCampaignSimple from "./StatusCampaignSimple";
import campaignsList from "./campaigns";

export default function AllCampaigns({ userID }) {
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    getCampaigns();
  }, [userID]);

  const getCampaigns = () => {
    const campaigns = campaignsList.filter(
      (campaign) => campaign.user_id == userID
    );

    setCampaigns(campaigns);
  };

  const generateTagCampaigns = () => {
    return campaigns.map((campaign, index) => {
      let textStateCampaign =
        StatusCampaignSimple.statusCampaignString()[campaign.status];

      let tagClass;
      switch (campaign.status) {
        case StatusCampaignSimple.statusCampaign.PENDING_TO_START_DATE:
          tagClass = "warning";
          break;
        case StatusCampaignSimple.statusCampaign.ACTIVE:
          tagClass = "success";
          break;
        case StatusCampaignSimple.statusCampaign.FINISHED:
          tagClass = "info";
          break;
        case StatusCampaignSimple.statusCampaign.CANCELED:
          tagClass = "danger";
          break;
      }

      return (
        <tr key={index}>
          <td>{helpersNumber.toPersianNum(index + 1)}</td>
          <td>{helpersNumber.toPersianNum(campaign.id)}</td>
          <td>{campaign.name}</td>
          <td>{campaign.category}</td>
          <td>{campaign.type}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.created_at)}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.start_date)}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.end_date)}</td>
          <td>
            <div className="text-center">
              <span className={`badge badge-${tagClass} `}>
                {textStateCampaign}
              </span>
            </div>
          </td>
          <td>
            <div>
              <span className="pl-2">
                <Link
                  className="btn btn-info"
                  to={`/campaigns/banner/simple/view/${campaign.id}`}
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <div className="py-2">
        <Link to="/campaigns/all-type" className="btn btn-success">
          <span className="pl-2">
            <i className="fa fa-plus"></i>
          </span>
          <span>اضافه کردن کمپین</span>
        </Link>
      </div>
      <div className="table-responsive ">
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>#</td>
              <td>شماره کمپین</td>
              <td>نام کمپین</td>
              <td>نام گروه نمایش دهنده</td>
              <td>نوع کمپین</td>
              <td>تاریخ ایجاد</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
              <td>وضعیت</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>{generateTagCampaigns()}</tbody>
        </table>
      </div>
    </>
  );
}
